import React from 'react';
import { Box } from '@mui/material';

const FloatingParticles = ({ count = 20 }) => {
    const particles = Array.from({ length: count }, (_, i) => ({
        id: i,
        size: Math.random() * 6 + 2,
        x: Math.random() * 100,
        y: Math.random() * 100,
        delay: Math.random() * 5,
        duration: Math.random() * 4 + 3,
        color: `rgba(255, ${77 + Math.random() * 50}, ${77 + Math.random() * 50}, ${Math.random() * 0.4 + 0.3})`
    }));

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                overflow: 'hidden',
                zIndex: 1,
            }}
        >
            {particles.map((particle) => (
                <Box
                    key={particle.id}
                    sx={{
                        position: 'absolute',
                        left: `${particle.x}%`,
                        top: `${particle.y}%`,
                        width: particle.size,
                        height: particle.size,
                        borderRadius: '50%',
                        background: particle.color,
                        animation: `floatParticle ${particle.duration}s ease-in-out ${particle.delay}s infinite`,
                        boxShadow: `0 0 ${particle.size * 2}px ${particle.color}`,
                    }}
                />
            ))}
        </Box>
    );
};

export default FloatingParticles;